import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return ({ namespace, type, folder, file }) =>
    present(
      repository
        .saveDocument(namespace, type, folder, file)
        .then((document) => ({ namespace, type, folder, document, file }))
        .catch(() => Promise.reject({ namespace, type, folder, file })),
    );
}

export type { Interactor };

export { createInteractor };
